import React from 'react';
import { FormFeedback, FormText } from 'reactstrap';
import { generateDecimalHelperText } from '@utils/survey/input';
import { hasNumericInput } from '@utils/universalTracker';
import { UniversalTrackerPlain } from '../../../../types/universalTracker';

export type GenerateHelperTextParams = {
  universalTracker: Pick<UniversalTrackerPlain, 'valueType' | 'valueValidation'>;
  warningMessage?: React.ReactNode;
  columnCode?: string;
};

const generateHelperText = (props: GenerateHelperTextParams) => {
  const { universalTracker, warningMessage, columnCode } = props;
  switch (true) {
    case hasNumericInput(universalTracker): {
      if (warningMessage) {
        return warningMessage;
      }
      return generateDecimalHelperText(universalTracker, columnCode);
    }
    default:
      return '';
  }
};

export const InputHelperText = (props: GenerateHelperTextParams & { invalidMessage: string | undefined }) => {
  const { invalidMessage, universalTracker } = props;
  if (invalidMessage) {
    return <FormFeedback>{invalidMessage}</FormFeedback>;
  }

  const helperText = universalTracker ? generateHelperText(props) : '';

  return helperText ? <FormText className='d-block w-100 ml-0 text-ThemeTextMedium'>{helperText}</FormText> : null;
};
